/* eslint-disable */
// react
import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { Router, Route, Switch } from 'react-router-dom';
// Actions
import SignAction from 'actions/SignAction';
import LoggedUserAction from 'actions/LoggedUserAction';
// Services
import SignService from 'services/SignService';
// Workers
import * as serviceWorker from 'workers/serviceWorker';
// PCP Components
import Main from 'components/page/MainLayout/MainLayout.jsx';
import LoadingPage from 'components/LoadingPage';

// create history for the user
const hist = createBrowserHistory();

// Initialisation of the current user if there is one
SignAction.autoLogin();

const renderApp = () => {
    // Mount the main component with the router
    ReactDOM.render(
        <Router history={hist}>
            <Switch>
                <Route path={'/'} component={Main} />;
            </Switch>
        </Router>, document.getElementById('root'));
}

// Mount the loader waiting for the main component
ReactDOM.render(
    <LoadingPage />, document.getElementById('root'));


if (localStorage.getItem('pricecomparator_token')) {
    SignService.tokenExists().then(response => {
        if (response) {  
            LoggedUserAction.initRights().then(() => renderApp());
        } else {
            SignAction.logout();
            renderApp();
        }
    });
} else {
    renderApp();
}

// Change unregister to register to launch the SW
serviceWorker.unregister();
